import { TranslationMap, Localize } from 'shared/i18n/interface'
import { useContext } from 'react'
import { StringDictionary } from 'shared/types/util'

import { formatString } from 'shared/localization'
import { IntlContext } from '~/app/features/FragmentRoot/contexts/IntlContext'
import { extractTranslationValue } from 'app/utils/extractTranslationValue'

/**
 * Gets the localized string for the given key
 *
 * @param {object} messages - object containing the localized strings
 * @param {string} key - key for which to get the localized string
 * @param {object?} replacements - replaces tokens in messages <token /> (by default) with the value from the object
 * @param {object?} interpolation - prefix/suffix overrides for string interpolation
 */
function getTranslationsFactory(messages: TranslationMap): Localize {
  return function getTranslation(key: string, replacements?: StringDictionary<string>, interpolation?: { prefix: string; suffix: string }): string {
    const message = messages[key]

    if (message === undefined) {
      throw new ReferenceError(`Could not find Intl message: ${key}`)
    }

    const extractedMessage = extractTranslationValue(message)

    if (extractedMessage === undefined) {
      throw new ReferenceError(`Could not find Intl message: ${key}`)
    }

    return formatString(extractedMessage, replacements, undefined, interpolation)
  }
}

export const useTranslations = (): Localize => {
  const { messages } = useContext(IntlContext)

  return getTranslationsFactory(messages)
}
